"use strict";

const HTMLElementImpl = require("./HTMLElement-impl").implementation;

class HTMLHeadingElementImpl extends HTMLElementImpl { }

module.exports = {
  implementation: HTMLHeadingElementImpl
};
